/**
 * Created by wwei on 2018-03-22.
 */
import ReactGA from "react-ga";
import { URL } from "../Constants.js";

export function saveGAEvent(category, action, label, value) {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: value
  });
}

export function saveGAView(pathname) {
  ReactGA.pageview(pathname);
}

const GA_DEFINITION = {
  continueBtn: {
    category: "login_discovery",
    action: "continue",
    label: ""
  },
  createOneLink: {
    category: "login_discovery",
    action: "register",
    label: ""
  },
  "step1.next": {
    category: "create_account",
    action: "step1_next",
    label: ""
  },
  "step1.back": {
    category: "create_account",
    action: "step1_back",
    label: ""
  },
  "step1.signin": {
    category: "create_account",
    action: "step1_sign_in",
    label: ""
  },
  "step2.next": {
    category: "create_account",
    action: "step2_next",
    label: ""
  },
  "step2.back": {
    category: "create_account",
    action: "step2_back",
    label: ""
  },
  "step2.signin": {
    category: "create_account",
    action: "step2_sign_in",
    label: ""
  },
  "step2.refresh": {
    category: "create_account",
    action: "capcha_refresh",
    label: ""
  },
  "step3.next": {
    category: "create_account",
    action: "step3_next",
    label: ""
  },
  "step3.back": {
    category: "create_account",
    action: "step3_back",
    label: ""
  },
  "step3.signin": {
    category: "create_account",
    action: "step3_sign_in",
    label: ""
  },
  "step4.here": {
    category: "create_account",
    action: "email_verification_resend",
    label: ""
  },
  "step4.signin": {
    category: "create_account",
    action: "step4_sign_in",
    label: ""
  },
  verifyBtn: [
    {
      category: "create_account",
      action: "verify_license_next",
      pathname: URL.SELF_REG_2,
      label: ""
    },
    {
      category: "licensing",
      action: "verify_license",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: "next"
    }
  ],
  "step5.signin": {
    category: "create_account",
    action: "step5_sign_in",
    label: ""
  },
  "step6.signin": {
    category: "create_account",
    action: "step6_sign_in",
    label: ""
  },
  licenseBackBtn: [
    {
      category: "create_account",
      action: "step6_back",
      pathname: URL.SELF_REG_2,
      label: ""
    },
    {
      category: "licensing",
      action: "activate_panel_back",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: ""
    }
  ],
  licenseCreateBtn: {
    category: "create_account",
    action: "created",
    label: ""
  },
  activateDoneBtn: {
    category: "create_account",
    action: "go_to_sign_in",
    label: ""
  },
  "prompt.yes": [
    {
      category: "create_account",
      action: "sign_in",
      label: "yes",
      pathname: URL.SELF_REG_2
    },
    {
      category: "account_code",
      action: "confirm",
      label: "yes",
      pathname: URL.TENANT_PORTAL.ACCOUNT_CODE
    },
    {
      category: "user_mgmt",
      action: "switch_account_type",
      pathname: URL.TENANT_PORTAL.USER,
      label: "yes"
    }
  ],
  "prompt.cancel": [
    {
      category: "create_account",
      action: "sign_in",
      label: "cancel",
      pathname: URL.SELF_REG_2
    },
    {
      category: "account_code",
      action: "create",
      label: "cancel",
      pathname: URL.TENANT_PORTAL.ACCOUNT_CODE
    },
    {
      category: "user_mgmt",
      action: "switch_account_type",
      pathname: URL.TENANT_PORTAL.USER,
      label: "cancel"
    }
  ],
  accountCodeBtn: {
    category: "account_code",
    action: "create",
    label: ""
  },
  accountCodeCopy: {
    category: "account_code",
    action: "copy",
    label: ""
  },
  accountCodeDel: {
    category: "account_code",
    action: "delete",
    label: ""
  },
  pdms_sp_link: {
    category: "landing",
    action: "navigate",
    label: "PDMS-SP"
  },
  device_analytic_link: {
    category: "landing",
    action: "navigate",
    label: "device_analytics"
  },
  pdms_e_link: {
    category: "landing",
    action: "navigate",
    label: "PDMS-E"
  },
  register_device_link: {
    category: "landing",
    action: "navigate",
    label: "register_devices"
  },
  a4b_link: {
    category: "landing",
    action: "navigate",
    label: "a4b"
  },
  plantronics_link: {
    category: "landing",
    action: "navigate",
    label: "plantronics"
  },
  real_access_link: {
    category: "landing",
    action: "navigate",
    label: "real_access"
  },
  real_connect_link: {
    category: "landing",
    action: "navigate",
    label: "real_connect"
  },
  one_touch_link: {
    category: "landing",
    action: "navigate",
    label: "otd"
  },
  admin_link: {
    category: "landing",
    action: "navigate",
    label: "administration"
  },
  content_menu: [
    {
      category: "device_content",
      action: "navigate",
      label: "device_content",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES
    },
    {
      category: "device_infra",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: "device_content"
    }
  ],
  infrastructure_menu: [
    {
      category: "device_content",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: "device_infra"
    },
    {
      category: "device_infra",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: "device_infra"
    }
  ],
  subAccount_menu: [
    {
      category: "user_mgmt",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.USER,
      label: "sub_account"
    },
    {
      category: "activity_logs",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACTIVITY,
      label: "sub_account"
    },
    {
      category: "licensing",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: "sub_account"
    },
    {
      category: "auth_provider",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: "sub_account"
    },
    {
      category: "account_code",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACCOUNT_CODE,
      label: "sub_account"
    },
    {
      category: "domain_management",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: "sub_account"
    },
    {
      category: "sub_account",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: "sub_account"
    }
  ],
  licenses_menu: [
    {
      category: "user_mgmt",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.USER,
      label: "licensing"
    },
    {
      category: "activity_logs",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACTIVITY,
      label: "licensing"
    },
    {
      category: "licensing",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: "licensing"
    },
    {
      category: "auth_provider",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: "licensing"
    },
    {
      category: "account_code",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACCOUNT_CODE,
      label: "licensing"
    },
    {
      category: "domain_management",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: "licensing"
    },
    {
      category: "sub_account",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: "licensing"
    }
  ],
  users_menu: [
    {
      category: "user_mgmt",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.USER,
      label: "user_mgmt"
    },
    {
      category: "activity_logs",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACTIVITY,
      label: "user_mgmt"
    },
    {
      category: "licensing",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: "user_mgmt"
    },
    {
      category: "auth_provider",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: "user_mgmt"
    },
    {
      category: "account_code",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACCOUNT_CODE,
      label: "user_mgmt"
    },
    {
      category: "domain_management",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: "user_mgmt"
    },
    {
      category: "sub_account",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: "user_mgmt"
    }
  ],
  logs_menu: [
    {
      category: "user_mgmt",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.USER,
      label: "activity_logs"
    },
    {
      category: "activity_logs",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACTIVITY,
      label: "activity_logs"
    },
    {
      category: "licensing",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: "activity_logs"
    },
    {
      category: "auth_provider",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: "activity_logs"
    },
    {
      category: "account_code",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACCOUNT_CODE,
      label: "activity_logs"
    },
    {
      category: "domain_management",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: "activity_logs"
    },
    {
      category: "sub_account",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: "activity_logs"
    }
  ],
  auth_provider_menu: [
    {
      category: "user_mgmt",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.USER,
      label: "auth_provider"
    },
    {
      category: "activity_logs",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACTIVITY,
      label: "auth_provider"
    },
    {
      category: "licensing",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: "auth_provider"
    },
    {
      category: "auth_provider",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: "auth_provider"
    },
    {
      category: "account_code",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACCOUNT_CODE,
      label: "auth_provider"
    },
    {
      category: "domain_management",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: "auth_provider"
    },
    {
      category: "sub_account",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: "auth_provider"
    }
  ],
  accountCode_menu: [
    {
      category: "user_mgmt",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.USER,
      label: "account_code"
    },
    {
      category: "activity_logs",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACTIVITY,
      label: "account_code"
    },
    {
      category: "licensing",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: "account_code"
    },
    {
      category: "auth_provider",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: "account_code"
    },
    {
      category: "account_code",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACCOUNT_CODE,
      label: "account_code"
    },
    {
      category: "domain_management",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: "account_code"
    },
    {
      category: "sub_account",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: "account_code"
    }
  ],
  domainMgmt_menu: [
    {
      category: "user_mgmt",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.USER,
      label: "domain_management"
    },
    {
      category: "activity_logs",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACTIVITY,
      label: "domain_management"
    },
    {
      category: "licensing",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: "domain_management"
    },
    {
      category: "auth_provider",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: "domain_management"
    },
    {
      category: "account_code",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.ACCOUNT_CODE,
      label: "domain_management"
    },
    {
      category: "domain_management",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: "domain_management"
    },
    {
      category: "sub_account",
      action: "navigate",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: "domain_management"
    }
  ],
  changePwd: {
    category: "profile",
    action: "change_password",
    label: "click"
  },
  logout: {
    category: "profile",
    action: "sign_out",
    label: ""
  },
  "changePwd.save": {
    category: "profile",
    action: "change_password",
    label: "save"
  },
  "changePwd.cancel": {
    category: "profile",
    action: "change_password",
    label: "cancel"
  },
  "switchOrg.link": {
    category: "profile",
    action: "switch_organization",
    label: "click"
  },
  "switchOrg.save": {
    category: "profile",
    action: "switch_organization",
    label: "save"
  },
  "switchOrg.cancel": {
    category: "profile",
    action: "switch_organization",
    label: "cancel"
  },
  "detail.save": {
    category: "profile",
    action: "change_names",
    label: "save"
  },
  "detail.cancel": {
    category: "profile",
    action: "change_names",
    label: "cancel"
  },
  refreshBtn: [
    // refresh button of tool bar
    {
      category: "device_content",
      action: "refresh",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: ""
    },
    {
      category: "device_infra",
      action: "refresh",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: ""
    },
    {
      category: "user_mgmt",
      action: "refresh",
      pathname: URL.TENANT_PORTAL.USER,
      label: ""
    },
    {
      category: "activity_logs",
      action: "refresh",
      pathname: URL.TENANT_PORTAL.ACTIVITY,
      label: ""
    },
    {
      category: "licensing",
      action: "refresh",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: ""
    },
    {
      category: "domain_management",
      action: "refresh",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: ""
    },
    {
      category: "sub_account",
      action: "refresh",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: ""
    }
  ],
  addBtn: [
    // add button of tool bar
    {
      category: "licensing",
      action: "activate_panel_open",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: ""
    },
    {
      category: "user_mgmt",
      action: "add_panel_open",
      pathname: URL.TENANT_PORTAL.USER,
      label: ""
    },
    {
      category: "device_infra",
      action: "add_device_by_pin",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: ""
    },
    {
      category: "domain_management",
      action: "add_panel_open",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: ""
    },
    {
      category: "sub_account",
      action: "add_panel_open",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: ""
    }
  ],
  editClosePanel: [
    {
      category: "device_content",
      action: "view_panel_close",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: ""
    },
    {
      category: "user_mgmt",
      action: "view_panel_close",
      pathname: URL.TENANT_PORTAL.USER,
      label: ""
    },
    {
      category: "auth_provider",
      action: "view_panel_close",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: ""
    },
    {
      category: "sub_account",
      action: "view_panel_close",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: ""
    }
  ],
  addClosePanel: [
    {
      category: "user_mgmt",
      action: "add_panel_close",
      pathname: URL.TENANT_PORTAL.USER,
      label: ""
    },
    {
      category: "licensing",
      action: "activate_panel_close",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: ""
    },
    {
      category: "domain_management",
      action: "add_panel_close",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: ""
    },
    {
      category: "sub_account",
      action: "add_panel_close",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: ""
    }
  ],
  downloadClosePanel: {
    category: "device_infra",
    action: "close",
    label: "download_relay"
  },
  licenseActivateBtn: {
    category: "licensing",
    action: "activated",
    label: ""
  },
  editSaveBtn: [
    {
      category: "device_infra",
      action: "save",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: ""
    },
    {
      category: "user_mgmt",
      action: "save",
      pathname: URL.TENANT_PORTAL.USER,
      label: ""
    },
    {
      category: "auth_provider",
      action: "enable",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: ""
    },
    {
      category: "sub_account",
      action: "save",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: ""
    }
  ],
  addSaveBtn: [
    {
      category: "user_mgmt",
      action: "new",
      pathname: URL.TENANT_PORTAL.USER,
      label: ""
    },
    {
      category: "domain_management",
      action: "new",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: ""
    },
    {
      category: "sub_account",
      action: "new",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: ""
    }
  ],
  deleteBtn: [
    {
      category: "device_content",
      action: "delete",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: ""
    },
    {
      category: "device_infra",
      action: "delete",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: ""
    },
    {
      category: "user_mgmt",
      action: "delete",
      pathname: URL.TENANT_PORTAL.USER,
      label: ""
    },
    {
      category: "auth_provider",
      action: "disable",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: ""
    },
    {
      category: "domain_management",
      action: "delete",
      pathname: URL.TENANT_PORTAL.DOMAIN_MANAGEMENT,
      label: ""
    },
    {
      category: "amazon_account",
      action: "delete",
      pathname: URL.A4B.AMAZON_ACCOUNT,
      label: ""
    },
    {
      category: "sub_account",
      action: "delete",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: ""
    }
  ],
  upload: {
    category: "device_infra",
    action: "upload",
    label: ""
  },
  advanced: {
    category: "device_infra",
    action: "advanced_settings",
    label: ""
  },
  rebootBtn: {
    category: "device_infra",
    action: "reboot",
    label: ""
  },
  pinRequired: {
    category: "device_content",
    action: "security_code",
    label: ""
  },
  selectObj: [
    {
      category: "device_content",
      action: "view_panel_open",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: ""
    },
    {
      category: "device_infra",
      action: "view_panel_open",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: ""
    },
    {
      category: "user_mgmt",
      action: "view_panel_open",
      pathname: URL.TENANT_PORTAL.USER,
      label: ""
    },
    {
      category: "auth_provider",
      action: "view_panel_open",
      pathname: URL.TENANT_PORTAL.AUTH_PRO,
      label: ""
    },
    {
      category: "sub_account",
      action: "view_panel_open",
      pathname: URL.TENANT_PORTAL.TENANT_OF_TENANT,
      label: ""
    }
  ],
  crDownloadBtn: {
    category: "device_infra",
    action: "cr_panel_open",
    label: ""
  },
  licenseAgreeLink: {
    category: "device_infra",
    action: "view_license_agreement_doc",
    label: ""
  },
  restrictionLink: {
    category: "device_infra",
    action: "view_restriction_doc",
    label: ""
  },
  downloadOVA: {
    category: "device_infra",
    action: "download_ova",
    label: ""
  },
  downloadHyperV: {
    category: "device_infra",
    action: "download_hyperV",
    label: ""
  },
  releaseNoteLink: {
    category: "device_infra",
    action: "view_release_note",
    label: ""
  },
  deployGuideLink: {
    category: "device_infra",
    action: "view_deployment_guide",
    label: ""
  },
  supportSiteLink: {
    category: "device_infra",
    action: "view_support_site",
    label: ""
  },
  agreeChk: [
    {
      category: "device_infra",
      action: "cr_download/tos_agree",
      pathname: URL.TENANT_PORTAL.CLOUD_DEVICES,
      label: ""
    },
    {
      category: "create_account",
      action: "create_account/has_key",
      pathname: URL.SELF_REG,
      label: ""
    },
    {
      category: "create_account",
      action: "create_account/tos_agree",
      pathname: URL.SELF_REG_2,
      label: ""
    },
    {
      category: "licensing",
      action: "licensing/tos_agree",
      pathname: URL.TENANT_PORTAL.LICENSE,
      label: ""
    }
  ],
  resendBtn: {
    category: "domain_management",
    action: "resend_email",
    label: ""
  },
  import365Btn: {
    category: "domain_management",
    action: "import_domain",
    label: ""
  },
  amazonSaveBtn: {
    category: "amazon_account",
    action: "save_amazon_account",
    label: ""
  },
  amazonTestBtn: {
    category: "amazon_account",
    action: "test_amazon_account",
    label: ""
  }
};

export default GA_DEFINITION;



// WEBPACK FOOTER //
// ./src/common/functions/GAUtils.js